module.exports = __webpack_public_path__ + "static/media/JSNKC1.26d1c416.png";